import React from "react";
import Contact from "./contact";

function page(){
    return(

        <>
        <Contact/>
        </>

    );
}
export default page;